/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_ListsInputs */

const en_palette_lists = /** @type {(inputs: Palette_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lists`)
};

/**
* | output |
* | --- |
* | "Lists" |
*
* @param {Palette_ListsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_lists = /** @type {((inputs?: Palette_ListsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_ListsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_lists(inputs)
});